import Accordion from "component/design-system/accordion/Accordion";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import { IFitmentOption } from "interfaces/session/IVehicle";
import { useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { forwardRef } from "react";
import styles from "./categoryFitmentOption.module.scss";

const CategoryFitmentOption = forwardRef((props: any, ref: any) => {
  const {
    children, filterKey, icon, title,
  } = props;

  const { selectedVehicle } = useSelector((store: RootState) => store.garage);

  if (!selectedVehicle) {
    return null;
  }

  const { fitmentOptions } = selectedVehicle;
  const selectedValue = fitmentOptions.find((option: IFitmentOption) => option.optionName === filterKey);

  // const accordionRef = useRef();

  const imgSrc = getRelativeImagePath(icon);

  const optionsComponent = (
    <Accordion
      title={selectedValue?.optionValue || `Select ${title}`}
      content={children}
      titleClassName={`${styles.accordion_title_className} ${!selectedValue?.optionValue ? styles.place_holder : ""} `}
      className={styles.accordion_container}
      closeFromOutsideClick
      contentClassName={styles.accordion_fitment_content}
      ref={ref}
    />
  );

  return (
    <div className={styles.container}>
      <div className={styles.title_container}>
        <HideIf show={icon}>
          <PAImage
            src={imgSrc}
            width={19}
            height={19}
            alt={title}
            className={styles.fitment_icon}
          />
        </HideIf>
        <PAText fontSize={FONT_SIZE[1]} color="black">{title}</PAText>
      </div>
      {optionsComponent}
    </div>
  );
});

CategoryFitmentOption.displayName = "CategoryFitmentOption";
export default CategoryFitmentOption;
